import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, ShieldCheck, Truck, BadgeCheck } from "lucide-react";
import SpinningLogo from "./SpinningLogo";

const Footer = () => (
  <footer className="mt-20 bg-[#102a1f] text-[#cfe0d6]">
    <div className="border-b border-white/10">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-6 py-10 sm:grid-cols-3">
        {[
          { icon: ShieldCheck, t: "Nasty Free", s: "No fillers, no stearates, no lies" },
          { icon: Truck, t: "Made in the UK", s: "Free shipping over £40" },
          { icon: BadgeCheck, t: "46,500+ Reviews", s: "Trusted by real people" },
        ].map((f, i) => (
          <div key={i} className="flex items-center gap-4">
            <f.icon size={30} className="text-[#74C69D]" />
            <div>
              <p className="font-display font-semibold uppercase tracking-wide text-white">{f.t}</p>
              <p className="text-sm text-[#9fb6a8]">{f.s}</p>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-6 py-12 md:grid-cols-4">
      <div className="col-span-2 md:col-span-1">
        <div className="mb-3 flex items-center gap-2">
          <SpinningLogo size={40} ring="ring-white/20" />
          <span className="font-display text-lg font-bold uppercase text-white">British Supplements</span>
        </div>
        <p className="text-sm leading-relaxed text-[#9fb6a8]">Clean, premium, high-strength supplements made in the UK — for the people, not big business.</p>
        <div className="mt-4 flex gap-3">
          {[Instagram, Facebook, Youtube].map((Ic, i) => (
            <a key={i} href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-[#2D6A4F]"><Ic size={17} /></a>
          ))}
        </div>
      </div>

      {[
        { h: "Shop", links: [["All Products", "/shop"], ["Men", "/shop/men"], ["Women", "/shop/women"], ["Bundles", "/shop/bundles"], ["Sale", "/shop/sale"]] },
        { h: "Help", links: [["FAQ", "/faq"], ["Our Story", "/our-story"], ["The Truth", "/our-story"], ["Men Over 40", "/shop/men40"], ["Women Over 40", "/shop/women40"]] },
        { h: "Legal", links: [["Disclaimer", "/disclaimer"], ["Privacy & Policies", "/policies"], ["Terms & Conditions", "/terms"]] },
      ].map((col, i) => (
        <div key={i}>
          <p className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-white">{col.h}</p>
          <ul className="space-y-2">
            {col.links.map(([l, to]) => (
              <li key={l}><Link to={to} className="text-sm text-[#9fb6a8] transition hover:text-[#95D5B2]">{l}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="border-t border-white/10 py-5 text-center text-xs text-[#7e9589]">
      © {new Date().getFullYear()} British Supplements · Real Health Supplements LTD · Made in the UK. This is a design concept with mock data.
    </div>
  </footer>
);

export default Footer;
